import { URLS } from './../constants'
import { dispatchFetchPost } from './ActionsUtil'
import {
  POST_CUSTOMER_BEGIN, POST_CUSTOMER_SUCCESS, POST_CUSTOMER_FAILURE
} from './../constants/ActionTypes'

const acPostCustomerBegin = () => ({ type: POST_CUSTOMER_BEGIN })
const acPostCustomerSuccess = () => ({ type: POST_CUSTOMER_SUCCESS })
const acPostCustomerFailure = err => ({ type: POST_CUSTOMER_FAILURE, payload: err })

export const acPostCustomer = data => {
  return dispatchFetchPost(
    URLS.POST_CUSTOMER,
    {
      cnpj: data.cnpj,
      cpf: data.cpf,
      name: data.name,
      email: data.email,
      phone_1: String(data.phone_1),
      password: data.password,
      referral: data.referral,
      ...data
    },
    acPostCustomerBegin,
    acPostCustomerSuccess,
    acPostCustomerFailure,
  )
}